import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard_rcs",
  "use": "dashboard_rcs-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"dashboard_rcs\"><path clip-rule=\"evenodd\" d=\"M29 25H15l-8 6v-6H3a2 2 0 01-2-2V3a2 2 0 012-2h26a2 2 0 012 2v20a2 2 0 01-2 2z\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M20 11a1 1 0 00-1-1M19 12a1 1 0 001-1M18 11a1 1 0 001 1M19 10a1 1 0 00-1 1\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M19.22 16.341a3.716 3.716 0 002.155-3.17c0-1.394-.743-3.171-2.459-3.171M13 11a1 1 0 00-1-1M12 12a1 1 0 001-1M11 11a1 1 0 001 1M12 10a1 1 0 00-1 1\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M12.22 16.341a3.716 3.716 0 002.155-3.17c0-1.394-.743-3.171-2.459-3.171\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dashboard_rcs.svg
// module id = /f+l
// module chunks = 39 44